
import { Typography } from "@mui/material"
import { Article } from "../../_/components/Article"
import ReactPlayer from "react-player"
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export const MainSplot = () => {
    return (
        <>



            <Typography variant="h1" align={'center'} gutterBottom>
                Splot
            </Typography>
            <Typography variant="h2" align={'center'} gutterBottom>
                System rpg
            </Typography>

            <ReactPlayer
                url="https://www.youtube.com/watch?v=rn3Ryq8opcI"
                controls={false}
                width="100%"
                height="50%"
            />
            
            <Article.Title>Splot</Article.Title>
            <Article.Body>
                Splot to gra wyobraźni
            </Article.Body>
        </>
    )
}